import type { DecoratedIntegration } from '@/pages/Schedule/hooks/useIntegrations';
import { List, StackDivider, VStack } from '@/ui';
import { IntegrationItem } from './IntegrationItem';

type ListProps = {
  integrations: DecoratedIntegration[];
};

export const IntegrationList = ({ integrations }: ListProps) => {
  return (
    <List
      alignItems="stretch"
      as={VStack}
      divider={<StackDivider borderColor="gray.100" pt="2" />}
      mb="4"
      spacing="1"
      w="100%"
    >
      {integrations.map((integration) => {
        return (
          <IntegrationItem integration={integration} key={integration.id} />
        );
      })}
    </List>
  );
};
